/**
 * AI Mode entry prompts — short user intents; runtime/Foundry prompts own the ops rules.
 */
import type { WizardFlow } from "./vysorFlows";

export type VysorAiGoalId = WizardFlow["id"];

const AI_GOAL_PROMPTS: Record<VysorAiGoalId, string> = {
  "configure-sso":
    "I want to configure SSO / company login. " +
    "Help me pick the application and environment, walk me through SAML or OIDC with secure defaults, " +
    "and collect anything still needed (like Entity ID and ACS) before submit.",
  "setup-app": "I want to add a new application.",
  "iga-entitlements":
    "I want to define who can access an app. " +
    "Help me pick the app and environment, then create an entitlement with a clear name and description.",
};

export function vysorAiGoalPrompt(flowId: VysorAiGoalId): string {
  return AI_GOAL_PROMPTS[flowId] || AI_GOAL_PROMPTS["configure-sso"];
}

/** Structural optionId for quick actions / goal chips — must travel with the prompt. */
export function vysorAiGoalOptionId(flowId: VysorAiGoalId): string {
  if (flowId === "setup-app") return "start_setup_app";
  if (flowId === "iga-entitlements") return "start_iga_entitlements";
  return "start_configure_sso";
}

export function vysorAiGoalUserLabel(flowId: VysorAiGoalId): string {
  if (flowId === "setup-app") return "Add a new app";
  if (flowId === "iga-entitlements") return "Who can access";
  return "Configure SSO";
}
